export const getBrands = ({ brandReducer: { brands = [] } = {} }) => brands;
export const getBrandFilter = ({ brandReducer: { filter = {} } = {} }) =>
  filter;
export const getBrandCount = ({ brandReducer: { count = 0 } = {} }) => count;
